// extracted by mini-css-extract-plugin
module.exports = {"aside":"a10a3f92e9--aside--uq1El"};